<template>
  <div class="dropdown-datepicker">
    <div>
      <DsDropdown
        ref="dropdown"
        :list-itens="[]"
        :placeholder-select="dateLabel"
        class="dropdown-datepicker__dropdown"
        label="Intervalo de datas"
      >
        <DatePickerWithDateList
          ref="datePickerWithDateListRef"
          :initial-date="initialDateRange"
          :period-list="periodList"
          @mouseLeaveFromDatePickerExpanded="onMouseLeave"
          @date-selected="handleDateSelected"
          @period-selected="handlePeriodSelected"
        />
      </DsDropdown>
    </div>
  </div>
</template>

<script>
import {
  format,
  parseISO,
  formatISO,
  sub,
  startOfDay,
  endOfDay,
  startOfWeek,
  startOfMonth,
  endOfMonth,
} from 'date-fns';

import { DsDropdown } from '@ds/components';

import { dispatchMixpanelTrack } from '@/utils';

import { DatePickerWithDateList } from '@/components/content/DatePickerWithDateList';

const today = new Date();
const yesterday = sub(today, { days: 1 });
const endOfToday = formatISO(endOfDay(today));
const lastMonth = sub(today, { months: 1 });
const sixDaysAgo = sub(today, { days: 6 });
const twentyNineDaysAgo = sub(today, { days: 29 });

export default {
  name: 'DropdownDatePicker',
  components: {
    DsDropdown,
    DatePickerWithDateList,
  },
  data() {
    return {
      selectedDate: null,
      initialDateRange: {
        start: formatISO(startOfDay(twentyNineDaysAgo)),
        end: endOfToday,
      },
      periodList: [
        {
          label: 'Hoje',
          start: formatISO(startOfDay(today)),
          end: endOfToday,
        },
        {
          label: 'Ontem',
          start: formatISO(startOfDay(yesterday)),
          end: formatISO(endOfDay(yesterday)),
        },
        {
          label: 'Semana atual',
          start: formatISO(startOfWeek(today)),
          end: endOfToday,
        },
        {
          label: 'Mês atual',
          start: formatISO(startOfMonth(today)),
          end: endOfToday,
        },
        {
          label: 'Mês passado',
          start: formatISO(startOfMonth(lastMonth)),
          end: formatISO(endOfMonth(lastMonth)),
        },
        {
          label: 'Últimos 7 dias',
          start: formatISO(startOfDay(sixDaysAgo)),
          end: endOfToday,
        },
        {
          label: 'Últimos 30 dias',
          start: formatISO(startOfDay(twentyNineDaysAgo)),
          end: endOfToday,
        },
      ],
      mixpanelProps: ['network', 'tab'],
    };
  },
  computed: {
    dateLabel() {
      const startDateRangeFormatted = format(parseISO(this.initialDateRange.start), 'dd/LL/yyyy');
      const endDateRangeFormatted = format(parseISO(this.initialDateRange.end), 'dd/LL/yyyy');

      return `${startDateRangeFormatted} - ${endDateRangeFormatted}`;
    },
  },
  mounted() {
    this.$store.dispatch('ui/addDateRange', this.initialDateRange);

    this.$watch(
      () => {
        return this.$refs.dropdown.openDropdown;
      }, (newValue) => {
        if (newValue) return this.handleOpenDropdown();
      });
  },
  methods: {
    onMouseLeave() {
      this.toggleDropdown();
    },
    toggleDropdown() {
      this.$refs.dropdown.toogleDropdown();
    },
    handleSelect(date) {
      this.toggleDropdown();

      this.initialDateRange = date;
      this.$store.dispatch('ui/addDateRange', { start: date.start, end: date.end });
    },
    handleDateSelected({ date }) {
      this.handleSelect(date);

      const dateRangeFormatted = {
        start: format(parseISO(date.start), 'dd-LL-yyyy'),
        end: format(parseISO(date.end), 'dd-LL-yyyy'),
      };

      dispatchMixpanelTrack('BM Calendar SelectButton Click', this.mixpanelProps, {
        answer: dateRangeFormatted,
      });
    },
    handlePeriodSelected({ date, label }) {
      this.handleSelect(date);

      dispatchMixpanelTrack('BM Calendar DateOption Click', this.mixpanelProps, {
        answer: label,
      });
    },
    handleOpenDropdown() {
      dispatchMixpanelTrack('BM Calendar Dropdown Click', this.mixpanelProps);
    },
  },
};
</script>

<style lang='scss' scoped>
.dropdown-datepicker {
  &__dropdown {
    width: 320px;
    height: 40px;

    ::v-deep {
      .ds-drop-down {
        width: 100%;
      }

      .ds-drop-down__placeholder-select,
      .ds-drop-down__top-border label {
        color: var(--ds-color-neutral);
      }

      .ds-drop-down__select {
        width: 320px;

        &:hover {
          border: var(--ds-border-width-hairline) solid var(--ds-color-gray-2);
          border-top: none;
        }
      }

      .ds-drop-down__icon {
        position: absolute;
        top: 50%;
        right: var(--ds-spacing-stack-nano);
        transform: translateY(-50%);
        margin: 0;
      }
    }
  }
}
</style>
